import { render, staticRenderFns } from "./OnboardingOptionsPicker.vue?vue&type=template&id=469045b6&scoped=true&"
import script from "./OnboardingOptionsPicker.vue?vue&type=script&lang=js&"
export * from "./OnboardingOptionsPicker.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingOptionsPicker.vue?vue&type=style&index=0&id=469045b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469045b6",
  null
  
)

export default component.exports